import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const getUserRole = () => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    try {
      const decodedToken = JSON.parse(atob(token.split(".")[1])); // Decoding JWT
      return decodedToken.role; // Assuming role is stored in the token
    } catch (error) {
      console.error("Invalid token:", error);
      return null;
    }
  }
  return null;
};

const flushCache = () => {
  sessionStorage.clear();
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
  });
  window.location.reload();
};

const SideBar = ({ isMobileOpen = false, onNavigate }) => {
  const role = getUserRole();
  const location = useLocation();
  const [isAdminOpen, setIsAdminOpen] = useState(false);

  const closeMobileIfNeeded = () => {
    if (typeof onNavigate === 'function') onNavigate();
  };

  const handleAdminSubmenuClick = () => {
    setIsAdminOpen(false);
    closeMobileIfNeeded();
  };

  // useEffect(() => {
  //   // Auto-open admin menu if on any admin-related route
  //   if (
  //     location.pathname.includes("/carter/manageRegistration") ||
  //     location.pathname.includes("/carter/citymanage") ||
  //     location.pathname.includes("/carter/users") ||
  //     location.pathname.includes("/carter/administrateInbox")
  //   ) {
  //     setIsAdminOpen(true);
  //   }
  // }, [location]);

  useEffect(() => {
    // Only auto-open when route changes to an admin route
    if (
      location.pathname.startsWith("/carter/manageRegistration") ||
      location.pathname.startsWith("/carter/clearSeasonList") ||
      location.pathname.startsWith("/carter/citymanage") ||
      location.pathname.startsWith("/carter/users") ||
      location.pathname.startsWith("/carter/administrateInbox")
    ) {
      setIsAdminOpen(true);
    } else {
      setIsAdminOpen(false);
    }
  }, [location.pathname]);


  return (
    <div id="sidebar" className={isMobileOpen ? 'active' : ''}>
      <div className="sidebar-header">
        <Link to="/carter/home" onClick={closeMobileIfNeeded}>
          <img src="/images/open-tennis-logo.png" className="img-responsive" alt="Play Open Tennis" />
        </Link>
      </div>
      <div id="main-nav">
        <Link 
          to="/carter/home" 
          className={`first ${location.pathname === '/carter/home' || location.pathname === '/carter' ? 'active' : ''}`}
          onClick={closeMobileIfNeeded}
        >
          Home
        </Link>
        <Link 
          to="/carter/profile" 
          className={location.pathname === '/carter/profile' ? 'active' : ''}
          onClick={closeMobileIfNeeded}
        >
          Player Profile
        </Link>
        <Link 
          to="/carter/schedule" 
          className={location.pathname.startsWith('/carter/schedule') ? 'active' : ''}
          onClick={closeMobileIfNeeded}
        >
          Schedule
        </Link>
        <Link 
          to="/carter/members" 
          className={location.pathname.startsWith('/carter/members') ? 'active' : ''}
          onClick={closeMobileIfNeeded}
        >
          Members
        </Link>
        <Link 
          to="/carter/courts" 
          className={location.pathname === '/carter/courts' ? 'active' : ''}
          onClick={closeMobileIfNeeded}
        >
          Courts
        </Link>
        <Link 
          to="/carter/standing" 
          className={location.pathname === '/carter/standing' ? 'active' : ''}
          onClick={closeMobileIfNeeded}
        >
          Leaderboard
        </Link>
        <Link 
          to="/carter/playoffs" 
          className={location.pathname === '/carter/playoffs' ? 'active' : ''}
          onClick={closeMobileIfNeeded}
        >
          Playoffs
        </Link>
        <Link 
          to="/carter/champions" 
          className={location.pathname === '/carter/champions' ? 'active' : ''}
          onClick={closeMobileIfNeeded}
        >
          Champions
        </Link>

        {/* Admin nav */}
        {role === 1 && (
          <div className="admin-link">
            <button
              type="button"
              className={`selected ${isAdminOpen ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                setIsAdminOpen(!isAdminOpen);
              }}
              style={{
                background: 'none',
                border: 'none',
                color: 'inherit',
                cursor: 'pointer',
                width: '100%',
                textAlign: 'left',
                padding: '10px 15px',
                textDecoration: 'none'
              }}
            >
              ADMIN
            </button>
            {isAdminOpen && (
              <div id="Admin" className="drop-menu">
                <Link 
                  to="/carter/manageRegistration"
                  className={location.pathname.startsWith('/carter/manageRegistration') ? 'active' : ''}
                  onClick={handleAdminSubmenuClick}
                >
                  Manage Seasons
                </Link>
                <Link
                  to="/carter/clearSeasonList"
                  className={location.pathname.startsWith('/carter/clearSeasonList') ? 'active' : ''}
                  onClick={handleAdminSubmenuClick}
                >
                  Clear Season List
                </Link>
                <Link 
                  to="/carter/citymanage"
                  className={location.pathname.startsWith('/carter/citymanage') ? 'active' : ''}
                  onClick={handleAdminSubmenuClick}
                >
                  Manage City
                </Link>
                <Link 
                  to="/carter/users"
                  className={location.pathname === '/carter/users' ? 'active' : ''}
                  onClick={handleAdminSubmenuClick}
                >
                  View Users
                </Link>
                <Link to="#" onClick={(e) => { e.preventDefault(); handleAdminSubmenuClick(); window.location.reload(); }}>Reload Options</Link>
                {/* <Link to="#" onClick={flushCache}>Flush Cache</Link> */}
                <Link 
                  to="/carter/administrateInbox"
                  className={location.pathname.startsWith('/carter/administrateInbox') ? 'active' : ''}
                  onClick={handleAdminSubmenuClick}
                >
                  Administrate Inbox
                </Link>
                {/* Add more links if needed */}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );

};

export default SideBar;
